import { render } from "./B2bPageAccountingCloseDrafts.vue?vue&type=template&id=0a2897e0&scoped=true&lang=pug"
import script from "./B2bPageAccountingCloseDrafts.vue?vue&type=script&lang=js"
export * from "./B2bPageAccountingCloseDrafts.vue?vue&type=script&lang=js"

import "./B2bPageAccountingCloseDrafts.vue?vue&type=style&index=0&id=0a2897e0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a2897e0"]])

export default __exports__